import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7aa8330b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7aa8330b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8330b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa8330b')) {
      api.createRecord('7aa8330b', component.options)
    } else {
      api.reload('7aa8330b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7aa8330b&scoped=true", function () {
      api.rerender('7aa8330b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wareProduct/index.vue"
export default component.exports